module.exports = __webpack_public_path__ + "static/img/green.da82192.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/green.jpg
// module id = /+B2
// module chunks = 8